import {
  Card,
  Row,
  Col,
  Form,
  Checkbox,
  Input,
  DatePicker,
  Table,
  Popconfirm,
  Modal,
  Button,
  Tooltip,
} from "antd";

import {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
  createElement,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { components } from "react-select";
import axios from "axios";
import { LAMBDAS } from "../../literals";
import jsPDF from "jspdf";
import dcf_logo from "../images/DCF_logo.png";
import TextArea from "antd/es/input/TextArea";
import Link from "antd/es/typography/Link";

import { CloseCircleTwoTone, SyncOutlined } from "@ant-design/icons";
import AgentViewList from "./AgentViewList";
// import { Tooltip } from "react-bootstrap";
import {
  setErrorCount_csallprograms_form,
  setErrorCount_csauthrep_form,
  setErrorCount_cssummaryscreen_form,
  setErrorCount_dcexpenselist_form,
  setErrorCount_dvsass_form,
  setErrorCount_emplistinclist_form,
  setErrorCount_expeditedstatus_form,
  setErrorCount_expenselist_form,
  setErrorCount_famplanchildcare_form,
  setErrorCount_householdstatuslist_form,
  setErrorCount_icebt_form,
  setErrorCount_icmawrs_form,
  setErrorCount_indemoscreen_form,
  setErrorCount_livingarrangement_form,
  setErrorCount_mdcareexpenselist_form,
  setErrorCount_mdexpenselist_form,
  setErrorCount_medcondlist_form,
  setErrorCount_narrative_form,
  setErrorCount_noncompliancelist_form,
  setErrorCount_noncustparentlist_form,
  setErrorCount_otherprogramlist_form,
  setErrorCount_pcscheduledlist_form,
  setErrorCount_pregnancylist_form,
  setErrorCount_purchasepreparelist_form,
  setErrorCount_registration_form,
  setErrorCount_relationshiplist_form,
  setErrorCount_reportingpage_form,
  setErrorCount_resourcelist_form,
  setErrorCount_right_resp_form,
  setErrorCount_runedbc_form,
  setErrorCount_schoolattlist_form,
  setErrorCount_screenpw_form,
  setErrorCount_screenvr_form,
  setErrorCount_tanfdt_form,
  setErrorCount_tanfsuspensionbased_form,
  setErrorCount_tanfwpcoop_form,
  setErrorCount_timelimitsummary_form,
  setErrorCount_todo_form,
  setErrorCount_verificationslist_form,
} from "../../actions/tracker_slice";
import {
  update_temp_data_form_type,
  update_answer_call_form,
  update_cctanf_form,
  update_childcareneedlist_form,
  update_childcareonly_form,
  update_citidentitylist_form,
  update_csallprograms_form,
  update_csauthrep_form,
  update_cssummaryscreen_form,
  update_dcexpenselist_form,
  update_dvsass_form,
  update_emplistinclist_form,
  update_expeditedstatus_form,
  update_expenselist_form,
  update_famplanchildcare_form,
  update_householdstatuslist_form,
  update_icebt_form,
  update_icmawrs_form,
  update_indemoscreen_form,
  update_livingarrangement_form,
  update_mdcareexpenselist_form,
  update_mdexpenselist_form,
  update_medcondlist_form,
  update_narrative_form,
  update_noncompliancelist_form,
  update_noncustparentlist_form,
  update_otherprogramlist_form,
  update_pcscheduledlist_form,
  update_pregnancylist_form,
  update_purchasepreparelist_form,
  update_registration_form,
  update_relationshiplist_form,
  update_reportingpage_form,
  update_resourcelist_form,
  update_right_resp_form,
  update_runedbc_form,
  update_schoolattlist_form,
  update_screenpw_form,
  update_screenvr_form,
  update_tanfdt_form,
  update_tanfsuspensionbased_form,
  update_tanfwpcoop_form,
  update_timelimitsummary_form,
  update_todo_form,
  update_verificationslist_form,
  setErrorCount_answer_call_form,
  setErrorCount_cctanf_form,
  setErrorCount_childcareneedlist_form,
  setErrorCount_childcareonly_form,
  setErrorCount_citidentitylist_form,
} from "../../actions/tracker_slice";

const AgentView = ({ onClickRefresh, contactID, agentId }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const temp_files = useSelector((state) => state.form.pdf_files);
  const [fileName, getFileName] = useState("");
  const [caseNum, setCaseNum] = useState("");
  const [agentName, setAgentName] = useState("");
  const [dataSource, set_datasource] = useState([
    // {
    //   // key: "1",
    //   fileName: "xxxjsjsjdhdfgfgdfgreyrtyrtahjdas",
    //   callAnswered: "Shena Trio",
    //   dateTimeSubmitted: "March 1, 2025 7:47 PM",
    // },
    // {
    //   fileName: "xxfffxjsjsjdhdgfdggdffahjdas",
    //   callAnswered: "Maria Gow",
    //   dateTimeSubmitted: "March 2, 2025 8:57 PM",
    // },
    // {
    //   fileName: "xxfffxjsjsjdhdfgdfgdfgdfahjdas",
    //   callAnswered: "Olashapo Ajala",
    //   dateTimeSubmitted: "March 3, 2025 3:47 PM",
    // },
    // {
    //   fileName: "xxffdffffxjsjsjdhdfahjdas",
    //   callAnswered: "Abenezer Ayana",
    //   dateTimeSubmitted: "March 4, 2025 2:27 PM",
    // },
  ]);
  const [columns, set_columns] = useState([
    {
      title: "Contact Id",
      dataIndex: "contactId",
      key: "contactId",
      // title: "Contact Id",
      // dataIndex: "contactId",
    },
    {
      title: "Case Number",
      dataIndex: "caseNumber",
      key: "caseNumber",
    },
    {
      title: "Case Name",
      dataIndex: "contactName",
      key: "contactName",
    },
    {
      title: "Agent Name",
      dataIndex: "agentName",
      key: "agentName",
    },
    {
      title: "Date Submitted",
      dataIndex: "dateTimeSubmitted",
      key: "dateTimeSubmitted",
    },
  ]);

  const [pdfData, setPdfData] = useState("");
  const [isEditing, setIsEditing] = useState(true);
  const [isDisplay, setIsDisplay] = useState(false);
  const [pdfText, setPdfText] = useState("Sample text here");
  const [getLastAgentUpdate, setLastAgentUpdate] = useState({
    "Last Update Details": [],
  });
  const [dataEdit, setDataEdit] = useState([]);
  const [contactId_file, setContactId_file] = useState("");
  // const isSuccessDisplay = useSelector((state) => state.form.isSuccess);

  const onRowClick = async (row_data) => {
    console.log("[onRowClick]", row_data);
    setContactId_file(row_data["contactId"]);
    setAgentName(row_data["agentName"]);
    let forms = await get_contact_data(
      row_data["caseNumber"],
      row_data["contactName"]
      // + "_" + row_data["agentFullName"].replace(/ /g, "")
    );
    console.log("[onRowClick][1]", forms);
    if (forms.length > 45) {
      forms.shift();
    } else if (forms.length === 45) {
      setLastAgentUpdate(forms[44]);
    }
    getFileName(
      row_data["fileName"]
      // + "_" + row_data["agentFullName"].replace(/ /g, "")
    );
    setDataEdit(forms);
    setCaseNum(row_data["caseNumber"]);
    displayEditText(forms);
  };

  const displayEditText = (textToEdit) => {
    let new_key;
    let formatted_text = textToEdit
      .map((obj) => {
        let key = Object.keys(obj)[0];
        let values = obj[key];
        if (key === "Last Update Details") {
          console.log("[displayEditText][0]", values);
          for (let key1 in values) {
            // console.log("[displayEditText][7]", key1);
            let new_value = `\t contactID: ${values[key1].contactId}\t Last Update by: ${values[key1]["Last Update by"]}\t Date and Time: ${values[key1]["Date and Time"]}`;
            values = { "": new_value };
          }
        }

        // console.log("[displayEditText][1]", values);
        let formatVal = Object.entries(values)
          .map(([k, v]) => `\t${k}:${v}`)
          .join("\n");
        if (key === "Last Update Details") {
          return `${key}\n${formatVal.replace(/^.*?:\s*/, "").trim()}`;
        } else {
          return `${key}\n${formatVal}`;
        }
      })
      .join("\n");

    // console.log("[1displayEditText]", formatted_text);
    setPdfText(formatted_text);
    setIsDisplay(true);
    setIsModalOpen(true);
  };

  const get_contact_data = async (case_number, contact_name) => {
    try {
      const { data: response } = await axios.get(
        LAMBDAS.GET_FORM_DETAILS +
          case_number +
          "&contactname=" +
          contact_name +
          "&agentId=" +
          agentId
      );
      let resp_data = response.response;
      console.log("[get_contact_data][DATA]", resp_data);

      return resp_data.form_details;
    } catch (error) {
      console.log("[get_contact_data][ERROR]", error);
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setIsEditing(true);
    onClickRefresh();

    dispatch(update_answer_call_form([]));
    dispatch(update_cctanf_form([]));
    dispatch(update_childcareneedlist_form([]));
    dispatch(update_childcareonly_form([]));
    dispatch(update_citidentitylist_form([]));
    dispatch(update_csallprograms_form([]));
    dispatch(update_csauthrep_form([]));
    dispatch(update_cssummaryscreen_form([]));
    dispatch(update_dcexpenselist_form([]));
    dispatch(update_dvsass_form([]));
    dispatch(update_emplistinclist_form([]));
    dispatch(update_expeditedstatus_form([]));
    dispatch(update_expenselist_form([]));
    dispatch(update_famplanchildcare_form([]));
    dispatch(update_expenselist_form([]));
    dispatch(update_householdstatuslist_form([]));
    dispatch(update_icebt_form([]));
    dispatch(update_icmawrs_form([]));
    dispatch(update_indemoscreen_form([]));
    dispatch(update_livingarrangement_form([]));
    dispatch(update_mdcareexpenselist_form([]));
    dispatch(update_mdexpenselist_form([]));
    dispatch(update_medcondlist_form([]));
    dispatch(update_narrative_form([]));
    dispatch(update_noncompliancelist_form([]));
    dispatch(update_noncustparentlist_form([]));
    dispatch(update_otherprogramlist_form([]));
    dispatch(update_pcscheduledlist_form([]));
    dispatch(update_pregnancylist_form([]));
    dispatch(update_purchasepreparelist_form([]));
    dispatch(update_registration_form([]));
    dispatch(update_relationshiplist_form([]));
    dispatch(update_reportingpage_form([]));
    dispatch(update_resourcelist_form([]));
    dispatch(update_right_resp_form([]));
    dispatch(update_runedbc_form([]));
    dispatch(update_schoolattlist_form([]));
    dispatch(update_screenpw_form([]));
    dispatch(update_screenvr_form([]));
    dispatch(update_tanfdt_form([]));
    dispatch(update_tanfsuspensionbased_form([]));
    dispatch(update_tanfwpcoop_form([]));
    dispatch(update_timelimitsummary_form([]));
    dispatch(update_todo_form([]));
    dispatch(update_verificationslist_form([]));
    dispatch(setErrorCount_answer_call_form(0));
    dispatch(setErrorCount_cctanf_form(0));
    dispatch(setErrorCount_childcareneedlist_form(0));
    dispatch(setErrorCount_childcareonly_form(0));
    dispatch(setErrorCount_citidentitylist_form(0));
    dispatch(setErrorCount_registration_form(0));
    dispatch(setErrorCount_csallprograms_form(0));
    dispatch(setErrorCount_cssummaryscreen_form(0));
    dispatch(setErrorCount_csauthrep_form(0));
    dispatch(setErrorCount_dcexpenselist_form(0));
    dispatch(setErrorCount_dvsass_form(0));
    dispatch(setErrorCount_emplistinclist_form(0));
    dispatch(setErrorCount_expeditedstatus_form(0));
    dispatch(setErrorCount_expenselist_form(0));
    dispatch(setErrorCount_famplanchildcare_form(0));
    dispatch(setErrorCount_householdstatuslist_form(0));
    dispatch(setErrorCount_icebt_form(0));
    dispatch(setErrorCount_icmawrs_form(0));
    dispatch(setErrorCount_indemoscreen_form(0));
    dispatch(setErrorCount_livingarrangement_form(0));
    dispatch(setErrorCount_mdcareexpenselist_form(0));
    dispatch(setErrorCount_mdexpenselist_form(0));
    dispatch(setErrorCount_medcondlist_form(0));
    dispatch(setErrorCount_narrative_form(0));
    dispatch(setErrorCount_noncompliancelist_form(0));
    dispatch(setErrorCount_noncustparentlist_form(0));
    dispatch(setErrorCount_otherprogramlist_form(0));
    dispatch(setErrorCount_pcscheduledlist_form(0));
    dispatch(setErrorCount_pregnancylist_form(0));
    dispatch(setErrorCount_purchasepreparelist_form(0));
    dispatch(setErrorCount_relationshiplist_form(0));
    dispatch(setErrorCount_reportingpage_form(0));
    dispatch(setErrorCount_resourcelist_form(0));
    dispatch(setErrorCount_right_resp_form(0));
    dispatch(setErrorCount_runedbc_form(0));
    dispatch(setErrorCount_schoolattlist_form(0));
    dispatch(setErrorCount_screenpw_form(0));
    dispatch(setErrorCount_screenvr_form(0));
    dispatch(setErrorCount_tanfdt_form(0));
    dispatch(setErrorCount_tanfsuspensionbased_form(0));
    dispatch(setErrorCount_tanfwpcoop_form(0));
    dispatch(setErrorCount_timelimitsummary_form(0));
    dispatch(setErrorCount_todo_form(0));
    dispatch(setErrorCount_verificationslist_form(0));
  };

  const handleTextChange = (text) => {
    setPdfText(text.target.value);
  };

  // useEffect(() => {
  //   console.log("[useEffect][isSuccessDisplay]", isSuccessDisplay);
  //   if (isSuccessDisplay) {
  //     console.log("[useEffect][isSuccessDisplay]", isSuccessDisplay);
  //     closeModal();
  //   }
  // }, []);

  useEffect(() => {
    const intervalID = setInterval(() => {
      console.log("[TEMPFILES]", temp_files);
      if (temp_files.length > 0) {
        let tempFile_display = temp_files[temp_files.length - 1].map((item) => {
          console.log("[ITEM-SOURCE]", item);
          // let [fileName, agentName] = item;
          // let [fileName, agentFullName] = item.fileName.split("_");
          // if (agentFullName && !agentFullName.includes(" ")) {
          //   agentFullName = agentFullName.replace(/([a-z])([A-Z])/g, "$1 $2");
          // }
          return {
            ...item,
            // fileName,
            // agentName,
          };
        });
        set_datasource(tempFile_display);
      }
    }, 5000); //interval is optional
    return () => clearInterval(intervalID);
  }, [temp_files]);

  return (
    <div
      style={{
        maxHeight: "100%",
        paddingLeft: "25px",
        paddingRight: "25px",
        overflow: "auto",
      }}
    >
      <Modal
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width="80%"
        maskClosable={false}
        destroyOnClose={true}
      >
        {!isEditing && (
          <div>
            <Row gutter={8} style={{ marginLeft: "85%", marginBottom: 10 }}>
              <Col span={20}></Col>
              <Col span={2}>
                <CloseCircleTwoTone
                  onClick={closeModal}
                  style={{ fontSize: "25px" }}
                />
              </Col>
            </Row>
            <AgentViewList
              isEditing={isEditing}
              dataToEdit={dataEdit}
              lastAgentUpdate={getLastAgentUpdate}
              fileName={fileName}
              contactId={contactId_file}
              caseNumber={caseNum}
              agentName={agentName}
            />
          </div>
        )}
        {isDisplay && isEditing && (
          <div>
            <Row gutter={8} style={{ marginLeft: "85%", marginBottom: 10 }}>
              <Col span={20}></Col>
              <Col span={2}>
                <CloseCircleTwoTone
                  onClick={closeModal}
                  style={{ fontSize: "25px" }}
                />
              </Col>
            </Row>
            <Input.TextArea
              value={pdfText}
              disabled={isEditing}
              onChange={handleTextChange}
              rows={5}
              style={{ width: "100%", height: "450px", color: "black" }}
            ></Input.TextArea>
            <Row style={{ marginTop: 15, marginLeft: "80%" }} gutter={8}>
              <Col span={12}>
                {isEditing === true ? (
                  <Button
                    onClick={() => setIsEditing(false)}
                    type="primary"
                    size="large"
                    style={{ width: "100%" }}
                  >
                    EDIT
                  </Button>
                ) : (
                  <Button type="primary" size="large" style={{ width: "100%" }}>
                    SAVE
                  </Button>
                )}
              </Col>
              <Col span={12}>
                <Button
                  onClick={() => setIsEditing(true)}
                  type="primary"
                  size="large"
                  style={{ width: "100%" }}
                >
                  CANCEL
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
      <Form
        form={form}
        // onValuesChange={handleFormChange}
        // onFinish={props.onFinish}
        labelAlign="justify"
        layout="vertical"
        labelWrap
        wrapperCol={{
          flex: 1,
        }}
      >
        {/* <label>Temporary Details</label> */}
        <Row gutter={8} style={{ marginLeft: "85%", marginBottom: 10 }}>
          <Col span={20}></Col>
          <Col span={2}>
            <Tooltip title="Refresh">
              <SyncOutlined
                onClick={onClickRefresh}
                style={{ fontSize: "25px", color: "royalblue" }}
              />
            </Tooltip>
          </Col>
        </Row>
        <Table
          components={components}
          bordered
          dataSource={dataSource}
          columns={columns}
          onRow={(rowData) => ({
            onClick: (e) => {
              onRowClick(rowData);
            },
          })}
          extra
          // pagination={{
          //   onChange: cancel,
          // }}
        />
      </Form>
    </div>
  );
};
export default AgentView;
